import { render, staticRenderFns } from "./ProjectSlide.vue?vue&type=template&id=60ec3b92&scoped=true"
import script from "./ProjectSlide.vue?vue&type=script&lang=ts"
export * from "./ProjectSlide.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSlide.vue?vue&type=style&index=0&id=60ec3b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec3b92",
  null
  
)

export default component.exports